import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-button-collapse',
    templateUrl: './button-collapse.component.html',
    styleUrls: ['./button-collapse.component.scss'],
    standalone: false
})
export class ButtonCollapseComponent {
  menuCollapsed: boolean;
  @Input() set menuHidden(value: boolean ) {
    this.menuCollapsed = value;
  }

  @Output() collapseClicked = new EventEmitter();

  clickCollapse() {
    this.menuCollapsed = !this.menuCollapsed;
    this.collapseClicked.emit();
  }

}
